/**
 * @category Core
 */
export enum PerformanceRating {
    VERY_LOW = 0,
    LOW = 1,
    MEDIUM = 2,
    HIGH = 3
}
